import HorizonCategoriesModule from '@/modules/horizon/categories';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/horizon/categories/')({
  component: HorizonCategoriesPage,
});

function HorizonCategoriesPage() {
  return <HorizonCategoriesModule />;
}
